import benefitsDataUa from '../data/BenefitsData/benefitsDataUa';
import { LangData } from '../types/langTypes';

const ua: LangData = {

  id: "ua",
  name: '',
  images: [],
  altText: '',
  description: '',
  portfolioDescription1: 'Респонсивний односторінковий сайт для бренду морозива: демонструє товари, секцію «як це зроблено», галерею та форму контакту. Побудований за допомогою HTML, CSS (mobile-first) та JavaScript.',
  portfolioDescription2: "Сучасний адаптивний і‑комерційний веб‑додаток з чистим UI/UX: фільтрація товарів у реальному часі, керування кошиком та дизайн під mobile-first. Технології: React, TypeScript, Redux та SCSS.",
  portfolioDescription3: "",
  portfolioDescription4: "",
  portfolioDescription5: "",
  portfolioDescription6: "",
  portfolioDescription: 'Опис портфоліо',
  backToTop: 'Назад наверх',
  mainNavigationLabel: "Головна навігація",
  mainNavigation: ['Головна', 'Про нас', 'Послуги', 'Портфоліо', 'Контакти'],

  logoTaglines: {

    top: "Думай сміливо",
    bottom: "Твори розумно",
  },
  home: "Головна",
  about: "Про нас",
  aboutmain: "Про нас",
  aboutTitle: "ПРО НАС",
  aboutSubtitle: "Архітектори цифрової переваги",
  aboutText: "SYDRIX — це точка, де висока інженерна естетика зустрічається з безкомпромісною бізнес-ефективністю. Заснована українським технологічним візіонером у серці Баварії, наша студія стала синонімом цифрової стійкості та інновацій. Ми не просто розробляємо інтерфейси — ми створюємо цифрові активи, які працюють на випередження ринку. Наш підхід базується на трьох стовпах: Performance-First (швидкість як релігія), Inclusive Design (доступність як стандарт) та Scalable Architecture (готовність до зростання вашого бізнесу вдесятеро). Ми віримо, що ідеальний код має бути невидимим, а результат — відчутним у кожному звіті про прибутки. З SYDRIX ви отримуєте не просто фронтенд, а технологічну перевагу, яка перетворює ваш бренд на лідера цифрової епохи.",
  aboutPhilosophyTitle: "Наша філософія",
  aboutPhilosophyText: "Ми замінюємо застарілі методи свіжим поглядом на продуктивність. Наш підхід гарантує архітектуру, яка не потребуватиме переробки через рік.",
  aboutButton: "Дізнатись більше",
  aboutButtonText: "Переглянути",
  aboutButtonLink: "/about",
  aboutImageAlt: "Зображення про нас",
  aboutList: [
    "Професійна команда",
    "Сучасні технології",
    "Індивідуальний підхід"
  ],
  aboutQuote: "Ми любимо те, що робимо!",
  aboutQuoteAuthor: "Засновник команди",
  aboutStats: [
    { label: "Стек розробки", value: "Next.js" },
    { label: "Фокус на якості", value: "100%" }
  ],
  aboutMission: "Ми перетворюємо складні технології на ваші стратегічні активи, забезпечуючи бізнесу лідерство в цифрову епоху.",
  aboutVision: "Стати глобальним еталоном фронтенд-інженерії, де кожен піксель працює на прибуток клієнта.",
  aboutValues: [
    "Інженерна бездоганність",
    "Радикальна прозорість",
    "Масштабовані інновації"
  ],
  aboutTeam: "Наша команда — наш головний актив.",
  aboutPartners: "Нам довіряють наші партнери.",
  aboutClients: "Наші клієнти — наші друзі.",
  aboutHistory: "Історія компанії почалась у 2025 році.",
  services: "Послуги",
  servicesTitle: "Наші послуги",
  servicesContactText: "Зв’яжіться з нами для деталей",
  servicesButton: "Дізнатись більше",
  servicesFormTitle: "Отримати безкоштовну консультацію",
  servicesFormPlaceholder: "Ваш email",
  servicesFormButton: "Надіслати",
  showLessButton: "Показати менше",
  showMoreButton: "Показати більше",
  noProjectsFound: "Проєкти не знайдено.",

  portfolio: "Портфоліо",
  portfolioTitle: "Портфоліо",
  portfolioText: "Ідеї, втілені в життя",
  portfolioLabel: "Портфоліо",
  viewOnGithub: "Переглянути на Github",

  testimonials: "Відгуки",
  testimonialsText: "Дякуємо всім нашим клієнтам за відгуки!",
  blogTitle: "Блог",
  contacts: "Контакти",
  contactsTitle: "Контакти",
  phone: "Телефон",
  email: "E-mail",
  faq: "Питання",
  partnership: "Партнерство",
  showAllButton: "Показати все",
  hideAllButton: "Сховати",
  title: "Фронтенд-розробка для вашого бізнесу",
  subtitle: [
    "Вражаюча швидкість.",
    "Запам’ятовуваний дизайн.",
    "Захопливий досвід."
  ],
  button: "Поговоримо",
  benefitsTitle: "Переваги співпраці з нами",
  benefitsSubtitle: "Чому обирають нас клієнти",
  benefitsText: "Ми створюємо сайти швидкі, безпечні та ефективні.",
  benefits: benefitsDataUa,
  goTo: "перейти до",
  heroTitle: "Фронтенд-розробка для вашого бізнесу",
  heroSubtitle: [
    "Вражаюча швидкість.",
    "Запам’ятовуваний дизайн.",
    "Захопливий досвід."
  ],
  heroButton: "Поговоримо",
  portfolioLink: "/portfolio",
  portfolioLinkText: "Переглянути портфоліо",

  serviceDetailsTitle: "Деталі послуг",
  serviceDetailsText: "Детальна інформація про наші послуги.",
  servicesDetailsButton: "Дізнатись більше про послугу",
  servicesDetailsSubtitle: "Більше про наші послуги",
  servicesDetailsList: ["Послуга 1", "Послуга 2", "Послуга 3"],
  notFoundTitle: "Сторінку не знайдено",
  notFoundText: "Вибачте, такої сторінки не існує.",
  notFoundButton: "На головну",
  cookieConsentText: "Цей сайт використовує cookies для покращення досвіду.",
  cookieConsentButton: "Зрозуміло",
  privacyPolicy: "Політика конфіденційності",
  termsOfService: "Умови обслуговування",
  loading: "Завантаження...",
  error: "Сталася помилка. Спробуйте ще раз.",
  success: "Успішно!",
  language: "Мова",
  selectLanguage: "Обрати мову",
  close: "Закрити",

  serviceDetailsBack: "Назад до послуг",
  faqTitle: "Часті питання",
  faqSubtitle: "Відповіді на поширені питання",
  faqText: "Якщо у вас є питання, перевірте цей розділ або зв’яжіться з нами.",
  team: "Команда",
  teamTitle: "Наша команда",
  teamText: "Ми — команда професіоналів, які люблять свою роботу.",
  process: "Процес",
  processTitle: "Як ми працюємо",
  processText: "Ми дотримуємося прозорого процесу розробки.",
  technologies: "Технології",
  technologiesTitle: "Технології, які ми використовуємо",
  technologiesText: "Ми використовуємо сучасні фреймворки та інструменти.",
  price: "Ціна",
  priceTitle: "Ціни на послуги",
  priceText: "Дізнайтесь більше про наші ціни.",

  processSubtitle: "Етапи роботи",
  teamSubtitle: "Знайомтесь з командою",
  teamButton: "Дізнатись більше про команду",
  teamButtonText: "Переглянути команду",
  processButton: "Дізнатись про процес",
  processButtonText: "Переглянути процес",
  technologiesSubtitle: "Наші технології",
  technologiesButton: "Дізнатись більше про технології",
  technologiesButtonText: "Переглянути технології",
  priceSubtitle: "Деталі цін",
  priceButton: "Дізнатись більше про ціни",
  priceButtonText: "Переглянути ціни",

  teamButtonLink: "/team",
  portfolioButton: "Дізнатись більше про портфоліо",
  portfolioButtonText: "Переглянути портфоліо",
  portfolioButtonLink: "/portfolio",
  blogButton: "Дізнатись більше про блог",
  blogButtonText: "Переглянути блог",
  blogButtonLink: "/blog",
  contactsButton: "Дізнатись більше про контакти",
  contactsButtonText: "Переглянути контакти",
  contactsButtonLink: "/contacts",
  faqButton: "Дізнатись більше про FAQ",
  faqButtonText: "Переглянути FAQ",
  faqButtonLink: "/faq",
  notFoundButtonText: "Повернутись на головну",
  cookieConsentMore: "Більше інформації",
  privacyPolicyButton: "Переглянути політику",
  termsOfServiceButton: "Переглянути умови",

  contactsButtonLinkText: "Перейти до контактів",
  cookieConsentLink: "/privacy-policy",
  privacyPolicyButtonText: "Переглянути політику конфіденційності",
  termsOfServiceButtonText: "Переглянути умови обслуговування",
  aboutButtonLinkText: "Детальніше про нас",
  servicesButtonLinkText: "Детальніше про послуги",
  portfolioButtonLinkText: "Детальніше про портфоліо",
  blogButtonLinkText: "Детальніше про блог",
  faqButtonLinkText: "Детальніше про FAQ",
  teamButtonLinkText: "Детальніше про команду",
  processButtonLinkText: "Детальніше про процес",
  technologiesButtonLinkText: "Детальніше про технології",
  priceButtonLinkText: "Детальніше про ціни",
  notFoundButtonLinkText: "Повернутись на головну",
  cookieConsentButtonText: "Зрозуміло",
  cookieConsentMoreText: "Більше інформації",

  faqQuestion: "Питання",
  faqAnswer: "Відповідь",
  priceButtonLink: "/price",
  processButtonLink: "/process",
  technologiesButtonLink: "/technologies",
  servicesButtonLink: "/services",
  notFoundButtonLink: "/",
  privacyPolicyLink: "/privacy-policy",
  termsOfServiceLink: "/terms-of-service",

  partnershipTitle: "Партнерство",
  partnershipSubtitle: "Можливості співпраці",
  partnershipText: "Ми відкриті до партнерств та нових можливостей співпраці.",
  notFoundBackButton: "Повернутись назад",
  extraField1: "Додаткове поле 1",
  extraField2: "Додаткове поле 2",

  notFoundLink: "/",
  cookieConsent: "Цей сайт використовує cookies для покращення вашого досвіду.",
  toggleMenu: "Перемкнути меню",
  noPortfolioItems: 'Портфоліо поки що пусте',
  noImages: 'Немає зображень',
  "footer": "Розроблено Артемом Сидоровим",
  "impressum.back": "Назад",
  "impressum.subtitle": "Юридична інформація",
  "impressum.infoTitle": "Інформація згідно з § 5 TMG",
  "impressum.owner": "Артем Сидоров",
  "impressum.address": "Hochriesstraße 29",
  "impressum.city": "83209 Prien am Chiemsee, Німеччина",
  "impressum.contactTitle": "Контакти",
  "impressum.email": "Email",
  "impressum.website": "Сайт",
  "impressum.copyrightTitle": "Авторське право",
  "impressum.disputeTitle": "Вирішення суперечок",
  "impressum.disputeText": "Європейська комісія надає платформу для онлайн-вирішення суперечок (OS):",
  "impressum.disclaimerTitle": "Відмова від відповідальності",
  "impressum.disclaimerText": "Відповідальність за зміст: Контент наших сторінок був створений з особливою ретельністю. Однак ми не можемо гарантувати точність, повноту та актуальність інформації. Як постачальник послуг, ми несемо відповідальність за власний контент на цих сторінках згідно із загальним законодавством. Відповідальність за посилання: Наша пропозиція містить посилання на зовнішні веб-сайти третіх сторін, на зміст яких ми не маємо впливу, тому не несемо за них відповідальності.",
  "impressum.phone": "Телефон",
  "impressum.taxStatus": "Згідно з § 19 UStG податок на додану вартість не стягується (статус малого бізнесу).",
  "impressum.responsible": "Особа, відповідальна за контент згідно з § 18 MStV",
  "impressum.disputeFinal": "Я не зобов’язаний брати участь у процедурах вирішення спорів в арбітражних комісіях.",
  "impressum.copyrightText": "Контент та роботи, створені власником сайту на цих сторінках, захищені законом про авторське право. Розмноження, редагування, розповсюдження та будь-який вид використання поза межами закону про авторське право потребують письмової згоди автора.",
  "impressum.rights": "Всі права захищені",
  "impressum.copyrightLinkText": "Закон Німеччини про авторське право (UrhG)",
  "privacy.title": "Політика конфіденційності",
  "privacy.intro": "Я дуже серйозно ставлюся до захисту ваших персональних даних. Цей сайт розроблений таким чином, щоб обробляти якомога менше даних.",
  "privacy.hostingTitle": "1. Зовнішній хостинг",
  "privacy.hostingText": "Цей веб-сайт обслуговується зовнішнім постачальником послуг (хостером). Персональні дані, зібрані на цьому сайті, зберігаються на серверах хостера. Це насамперед включає IP-адреси та метадані. Використання хостера здійснюється в інтересах безпечного та швидкого надання нашого онлайн-сервісу професійним постачальником (ст. 6 ч. 1 літ. f GDPR).",
  "privacy.dataTitle": "2. Мінімізація даних",
  "privacy.dataText": "З метою мінімізації даних цей сайт відмовляється від використання файлів cookie, інструментів аналізу (відстеження) та форм зворотного зв'язку. Оцінка вашої поведінки як користувача не проводиться.",
  "privacy.rightsTitle": "3. Права суб'єкта даних",
  "privacy.rightsText": "Відповідно до чинних законодавчих положень, ви маєте право в будь-який час на безкоштовне отримання інформації про ваші збережені персональні дані, а також право на виправлення або видалення цих даних.",
  "privacy.contactTitle": "4. Відповідальна особа",
  "privacy.contactText": "Відповідальним за обробку даних є Артем Сидоров. Повні контактні дані можна знайти в розділі Impressum на цьому сайті.",
};

export default ua;

